export const formatParticipantsLabel = (
  currentParticipants: number,
  maxParticipants: number,
  options?: {
    includeParticipantsWord?: boolean;
  }
): string => {
  const includeWord = options?.includeParticipantsWord ?? true;

  if (maxParticipants > 0) {
    return includeWord
      ? `${currentParticipants}/${maxParticipants} participants`
      : `${currentParticipants}/${maxParticipants}`;
  }

  return includeWord
    ? `${currentParticipants} participants (Open Spot)`
    : `${currentParticipants} (Open Spot)`;
};


